/**
 * Convert an object into a unique hash
 */
export const hashObject = function(obj) {
  return btoa(
    // If we don't encodeURIComponent here we can hit the error
    // Failed to execute 'btoa' on 'Window': The string to be encoded contains
    // characters outside of the Latin1 range.
    unescape(encodeURIComponent(JSON.stringify(obj))),
  )
}

/**
 * Generate a unique id, under the hood does not actually guarantee its unique
 * but assumes will be with enough randomness.
 * @returns {string}
 */
export const generateUniqueId = function() {
  var charSet =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    len = 16
  var randomString = ''
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length)
    randomString += charSet.substring(randomPoz, randomPoz + 1)
  }
  return randomString
}
